import re from "react";
var R = { exports: {} }, _ = {};
var $;
function te() {
  if ($) return _;
  $ = 1;
  var u = /* @__PURE__ */ Symbol.for("react.transitional.element"), a = /* @__PURE__ */ Symbol.for("react.fragment");
  function f(d, s, l) {
    var m = null;
    if (l !== void 0 && (m = "" + l), s.key !== void 0 && (m = "" + s.key), "key" in s) {
      l = {};
      for (var p in s)
        p !== "key" && (l[p] = s[p]);
    } else l = s;
    return s = l.ref, {
      $$typeof: u,
      type: d,
      key: m,
      ref: s !== void 0 ? s : null,
      props: l
    };
  }
  return _.Fragment = a, _.jsx = f, _.jsxs = f, _;
}
var E = {};
var I;
function ne() {
  return I || (I = 1, process.env.NODE_ENV !== "production" && (function() {
    function u(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === Q ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case T:
          return "Fragment";
        case J:
          return "Profiler";
        case q:
          return "StrictMode";
        case X:
          return "Suspense";
        case H:
          return "SuspenseList";
        case Z:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case U:
            return "Portal";
          case z:
            return e.displayName || "Context";
          case V:
            return (e._context.displayName || "Context") + ".Consumer";
          case G:
            var r = e.render;
            return e = e.displayName, e || (e = r.displayName || r.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case B:
            return r = e.displayName || null, r !== null ? r : u(e.type) || "Memo";
          case k:
            r = e._payload, e = e._init;
            try {
              return u(e(r));
            } catch {
            }
        }
      return null;
    }
    function a(e) {
      return "" + e;
    }
    function f(e) {
      try {
        a(e);
        var r = !1;
      } catch {
        r = !0;
      }
      if (r) {
        r = console;
        var t = r.error, n = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t.call(
          r,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          n
        ), a(e);
      }
    }
    function d(e) {
      if (e === T) return "<>";
      if (typeof e == "object" && e !== null && e.$$typeof === k)
        return "<...>";
      try {
        var r = u(e);
        return r ? "<" + r + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function s() {
      var e = g.A;
      return e === null ? null : e.getOwner();
    }
    function l() {
      return Error("react-stack-top-frame");
    }
    function m(e) {
      if (y.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning) return !1;
      }
      return e.key !== void 0;
    }
    function p(e, r) {
      function t() {
        w || (w = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          r
        ));
      }
      t.isReactWarning = !0, Object.defineProperty(e, "key", {
        get: t,
        configurable: !0
      });
    }
    function M() {
      var e = u(this.type);
      return N[e] || (N[e] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), e = this.props.ref, e !== void 0 ? e : null;
    }
    function W(e, r, t, n, v, O) {
      var o = t.ref;
      return e = {
        $$typeof: S,
        type: e,
        key: r,
        props: t,
        _owner: n
      }, (o !== void 0 ? o : null) !== null ? Object.defineProperty(e, "ref", {
        enumerable: !1,
        get: M
      }) : Object.defineProperty(e, "ref", { enumerable: !1, value: null }), e._store = {}, Object.defineProperty(e._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(e, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(e, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: v
      }), Object.defineProperty(e, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: O
      }), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
    }
    function j(e, r, t, n, v, O) {
      var o = r.children;
      if (o !== void 0)
        if (n)
          if (K(o)) {
            for (n = 0; n < o.length; n++)
              A(o[n]);
            Object.freeze && Object.freeze(o);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else A(o);
      if (y.call(r, "key")) {
        o = u(e);
        var c = Object.keys(r).filter(function(ee) {
          return ee !== "key";
        });
        n = 0 < c.length ? "{key: someKey, " + c.join(": ..., ") + ": ...}" : "{key: someKey}", F[o + n] || (c = 0 < c.length ? "{" + c.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          n,
          o,
          c,
          o
        ), F[o + n] = !0);
      }
      if (o = null, t !== void 0 && (f(t), o = "" + t), m(r) && (f(r.key), o = "" + r.key), "key" in r) {
        t = {};
        for (var x in r)
          x !== "key" && (t[x] = r[x]);
      } else t = r;
      return o && p(
        t,
        typeof e == "function" ? e.displayName || e.name || "Unknown" : e
      ), W(
        e,
        o,
        t,
        s(),
        v,
        O
      );
    }
    function A(e) {
      P(e) ? e._store && (e._store.validated = 1) : typeof e == "object" && e !== null && e.$$typeof === k && (e._payload.status === "fulfilled" ? P(e._payload.value) && e._payload.value._store && (e._payload.value._store.validated = 1) : e._store && (e._store.validated = 1));
    }
    function P(e) {
      return typeof e == "object" && e !== null && e.$$typeof === S;
    }
    var b = re, S = /* @__PURE__ */ Symbol.for("react.transitional.element"), U = /* @__PURE__ */ Symbol.for("react.portal"), T = /* @__PURE__ */ Symbol.for("react.fragment"), q = /* @__PURE__ */ Symbol.for("react.strict_mode"), J = /* @__PURE__ */ Symbol.for("react.profiler"), V = /* @__PURE__ */ Symbol.for("react.consumer"), z = /* @__PURE__ */ Symbol.for("react.context"), G = /* @__PURE__ */ Symbol.for("react.forward_ref"), X = /* @__PURE__ */ Symbol.for("react.suspense"), H = /* @__PURE__ */ Symbol.for("react.suspense_list"), B = /* @__PURE__ */ Symbol.for("react.memo"), k = /* @__PURE__ */ Symbol.for("react.lazy"), Z = /* @__PURE__ */ Symbol.for("react.activity"), Q = /* @__PURE__ */ Symbol.for("react.client.reference"), g = b.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, y = Object.prototype.hasOwnProperty, K = Array.isArray, h = console.createTask ? console.createTask : function() {
      return null;
    };
    b = {
      react_stack_bottom_frame: function(e) {
        return e();
      }
    };
    var w, N = {}, C = b.react_stack_bottom_frame.bind(
      b,
      l
    )(), Y = h(d(l)), F = {};
    E.Fragment = T, E.jsx = function(e, r, t) {
      var n = 1e4 > g.recentlyCreatedOwnerStacks++;
      return j(
        e,
        r,
        t,
        !1,
        n ? Error("react-stack-top-frame") : C,
        n ? h(d(e)) : Y
      );
    }, E.jsxs = function(e, r, t) {
      var n = 1e4 > g.recentlyCreatedOwnerStacks++;
      return j(
        e,
        r,
        t,
        !0,
        n ? Error("react-stack-top-frame") : C,
        n ? h(d(e)) : Y
      );
    };
  })()), E;
}
var D;
function oe() {
  return D || (D = 1, process.env.NODE_ENV === "production" ? R.exports = te() : R.exports = ne()), R.exports;
}
var i = oe();
const L = {
  bg: {
    "pnf.oops": "Оопс!",
    "pnf.title": "404 - Страницата не е намерена",
    "pnf.message": "Страницата, която търсите, може да е временно недостъпна или е премахната.",
    "pnf.button": "Начална страница"
  },
  en: {
    "pnf.oops": "Oops!",
    "pnf.title": "404 - Page not found",
    "pnf.message": "The page you are looking for might have been temporarily unavailable or it is removed.",
    "pnf.button": "Go To Homepage"
  },
  ru: {
    "pnf.oops": "Упс!",
    "pnf.title": "404 - Страница не найдена",
    "pnf.message": "Страница, которую вы ищете, могла быть временно недоступна или удалена.",
    "pnf.button": "Пойдите на домашнюю страницу"
  }
}, se = ({ lang: u }) => {
  let a = L[u];
  return a || (a = L.bg), /* @__PURE__ */ i.jsx("div", { id: "notFound", children: /* @__PURE__ */ i.jsxs("div", { className: "notFound", children: [
    /* @__PURE__ */ i.jsx("div", { className: "notFound-404", children: /* @__PURE__ */ i.jsx("h1", { children: a["pnf.oops"] }) }),
    /* @__PURE__ */ i.jsx("h2", { children: a["pnf.title"] }),
    /* @__PURE__ */ i.jsx("p", { children: a["pnf.message"] }),
    /* @__PURE__ */ i.jsx("a", { href: "/", children: a["pnf.button"] })
  ] }) });
};
export {
  se as PageNotFound
};
